import { Model, Types } from '~app/core/model';

const Position = Model.createType({
  name: 'Position',
  fields: {
    x: Types.NUMBER(),
    y: Types.NUMBER(),
  },
});

Position.prototype.add = function (other) {
  return this.clone({
    x: this.x + other.x,
    y: this.y + other.y,
  });
};

Position.prototype.lerp = function (other, fraction) {
  return this.clone({
    x: this.x + fraction * (other.x - this.x),
    y: this.y + fraction * (other.y - this.y),
  });
};

Position.prototype.serialize = function () {
  return { x: this.x, y: this.y };
};

export default Position;
